module.exports = __webpack_public_path__ + "img/tag-management.64eafb93.svg";